import { useState } from 'react';

const useNewProjectTask = ({ lastIndex, lastPosition }) => {
  const date = new Date();

  const [newTask, setNewTask] = useState(null);

  const addNewTask = ({ index, position }) => {
    setNewTask({
      id: `new-task-${date.getTime()}`,
      details: '',
      completed: false,
      isNew: true,
      position,
      index,
      images: [],
      videos: [],
      assignedUsers: [],
    });
  };

  const addNewTaskAtEnd = () => {
    addNewTask({
      index: lastIndex,
      position: lastPosition,
    });
  };

  const removeNewTask = () => {
    setNewTask(null);
  };

  return {
    newTask,
    addNewTask,
    addNewTaskAtEnd,
    removeNewTask,
  };
};

export default useNewProjectTask;
